
export const ORDER_UPLOAD = "/orderupload";
export const ORDER_DOWNLOAD = ORDER_UPLOAD + "/download";